<template>
  <div class="main">
    <div class="main-wrapper">
      <div class="card-header">Currencies List</div>
      <v-divider></v-divider>
      <div class="card-body">
        <v-card>
          <v-card-title>
            <v-btn
              v-if="selectedRows.length"
              @click="deleteCurrency"
              :loading="deleteLoading"
              >Delete</v-btn
            >
          </v-card-title>
          <v-data-table
            show-select
            v-model="selectedRows"
            :loading="!currencyTypes"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="currencyTypes"
            :search="searchInput"
          >
            <template v-slot:item.name="props">
              <v-edit-dialog
                :return-value.sync="props.item.name"
                @save="save(props.item)"
              >
                {{ props.item.name }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.name"
                    :rules="[max25chars]"
                    label="Edit"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:item.symbol="props">
              <v-edit-dialog
                :return-value.sync="props.item.symbol"
                @save="save(props.item)"
              >
                <div v-html="props.item.symbol"></div>
                <template v-slot:input>
                  <div class="mt-4 text-h6">Update Iron</div>
                  <v-text-field
                    v-model="props.item.symbol"
                    :rules="[max25chars]"
                    label="Edit"
                    single-line
                    counter
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
export default {
  name: "currencies",
  data() {
    return {
      selectedRows: [],
      deleteLoading: false,
      max25chars: (v) => v.length <= 25 || "Input too long!",
      searchInput: null,
      headers: [
        { text: "ID", align: "start", value: "id" },
        { text: "Name", align: "center", value: "name" },
        { text: "Symbol", align: "center", value: "symbol" },
        { text: "Rate (AMD)", align: "center", value: "rate" },
      ],
    };
  },
  apollo: {
    currencyTypes: {
      query: gql`
        query currencyTypes {
          currencyTypes {
            id
            name
            symbol
            rate
          }
        }
      `,
    },
  },
  methods: {
    save(item) {
      this.$apollo.mutate({
        mutation: gql`
          mutation updateCurrencyType(
            $id: ID!
            $name: String
            $symbol: String
          ) {
            updateCurrencyType(id: $id, name: $name, symbol: $symbol) {
              id
            }
          }
        `,
        variables: {
          id: +item.id,
          name: item.name,
          symbol: item.symbol,
        },
      });
    },
    deleteCurrency() {
      this.deleteLoading = true;
      this.selectedRows.forEach((currency, index) => {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation deleteCurrencyType($id: ID!) {
                deleteCurrencyType(id: $id) {
                  id
                }
              }
            `,
          })
          .then(() => {
            this.currencyTypes.splice(index, 1);
            this.deleteLoading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.main {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: #e6e7eb;
  padding-top: 100px;
  padding-left: 50px;
}
.main-wrapper {
  width: 94%;
  margin: 0 auto;
  margin-left: 80px;
  margin-right: 50px;
  border: 1px solid darkgray;
  border-radius: 5px;
  background: white;
}

/*Card Header*/
.card-header {
  font-size: 24px;
  background: white;
  font-weight: 600;
}
@media only screen and (max-width: 1520px) {
.main-wrapper {
  width: 92%;
}
}
@media only screen and (max-width: 1263px) {
.main {
  padding-left: 0 !important;
}
.main-wrapper {
  width: 90%;
  margin: auto !important;
}
}
@media only screen and (max-width: 1024px) {
.main-wrapper {
  width: 85%;
}
}
@media only screen and (max-width: 670px) {
.main-wrapper {
  width: 80%;
}
}
</style>
